import { render, staticRenderFns } from "./coffee-search-bar.vue?vue&type=template&id=5c3ae627&scoped=true&"
import script from "./coffee-search-bar.vue?vue&type=script&lang=js&"
export * from "./coffee-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./coffee-search-bar.vue?vue&type=style&index=0&id=5c3ae627&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ae627",
  null
  
)

export default component.exports